import * as React from 'react';
import {VOIState} from "../../../state/modules/voi";
import {LabelStyles} from "../../../ap/base/label";
import * as gls from '../../../ap/layout/gls';


export interface TransactedAddressSelectorProps {
  useClientAddress: boolean,
  useClientAddressAsTransactedAddress: (boolean) => void
}

class TransactedAddressSelector extends React.Component<TransactedAddressSelectorProps, VOIState> {

  constructor(props) {

    super(props);
  }

  useClientAddress = () => {
    this.props.useClientAddressAsTransactedAddress(true);
  }

  manuallyEnterTransactedAddress = () => {
    this.props.useClientAddressAsTransactedAddress(false);
  }

  render() {

    return (
      <div id="address-transacted-address-selector-container">
        <gls.ContentVerticalContentMargined margin={8}>
          <label htmlFor="useClientAddress" className={LabelStyles.rootClass}>
            Is the above address the property being transacted?
          </label>

          <gls.FlexHorizontalCentered>
            <input type="radio" name="useClientAddress" value="Yes" checked={!!this.props.useClientAddress} onChange={this.useClientAddress} />
            <gls.SmallHorizontalSpace space={10}/>
            <label className={LabelStyles.rootClass}>Yes</label>
          </gls.FlexHorizontalCentered>
          <gls.FlexHorizontalCentered>
            <input type="radio" name="useClientAddress" value="No" checked={!this.props.useClientAddress} onChange={this.manuallyEnterTransactedAddress} />
            <gls.SmallHorizontalSpace space={10}/>
            <label className={LabelStyles.rootClass}>No</label>
          </gls.FlexHorizontalCentered>

        </gls.ContentVerticalContentMargined>

      </div>
    );
  }

}

export default TransactedAddressSelector;
